import { ReactNode, useMemo, type JSX } from 'react';

import classNames from 'classnames';

export type GutterItemProps = {
  children: ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
  [key: string]: any;
};

export const GutterItem = ({
  children,
  className,
  as,
  ...props
}: GutterItemProps) => {
  const Element = useMemo(() => as || 'div', [as]);

  return (
    <Element {...props} className={classNames('gutter__item', className)}>
      {children}
    </Element>
  );
};
